import script from "./type.vue?vue&type=script&setup=true&lang=js"
export * from "./type.vue?vue&type=script&setup=true&lang=js"

import "./type.vue?vue&type=style&index=0&id=01ad1ba0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ad1ba0"]])

export default __exports__